module.exports = __webpack_public_path__ + "static/img/Eight of Cups.794a1f3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Eight of Cups.jpg
// module id = 1261
// module chunks = 0